export default "__VITE_ASSET__DmmLzpTH__"